"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var antd_mobile_1 = require("antd-mobile");
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var icon_1 = require("./../../icon");
var Items_1 = __importDefault(require("./Items"));
var ProductServiceMobile = function (props) {
    var flexTitle = props.flexTitle, serviceTitle = props.serviceTitle, _a = props.productList, productList = _a === void 0 ? [] : _a, _b = props.service, service = _b === void 0 ? [] : _b, _c = props.moreData, moreData = _c === void 0 ? {} : _c, backgroundImage = props.backgroundImage;
    var href = moreData.href, txt = moreData.txt, _d = moreData.extendProps, extendProps = _d === void 0 ? {} : _d;
    var _e = (0, react_1.useState)(0), activeKey = _e[0], setActiveKey = _e[1];
    // 指定移动端容器前缀
    var preSwiperName = 'swiper';
    var backgroundProps = backgroundImage ? { backgroundImage: "url(".concat(backgroundImage, ")") } : {};
    return (react_1.default.createElement("section", { className: "swiper" },
        react_1.default.createElement("div", { className: "".concat(preSwiperName, "__container") },
            react_1.default.createElement(Items_1.default, { service: service }),
            react_1.default.createElement("div", { className: "".concat(preSwiperName, "__fix"), style: backgroundProps },
                react_1.default.createElement("div", { className: "".concat(preSwiperName, "__immobility") },
                    react_1.default.createElement("span", { className: "".concat(preSwiperName, "__title") }, flexTitle),
                    react_1.default.createElement("span", { className: "".concat(preSwiperName, "__desc") }, serviceTitle)))),
        react_1.default.createElement(antd_mobile_1.Collapse, { arrow: react_1.default.createElement(icon_1.Icon, { name: "arrow-down", size: 24 }), accordion: true, className: "".concat(preSwiperName, "__collapse"), onChange: function (key) {
                setActiveKey(Number(key));
            } }, productList.map(function (item, i) {
            var title = item.title, _a = item.list, list = _a === void 0 ? [] : _a;
            return (react_1.default.createElement(antd_mobile_1.Collapse.Panel, { key: "".concat(i + 1), title: title, className: (0, classnames_1.default)({
                    actived: activeKey === i + 1,
                }) }, list.map(function (items, index) {
                var _a = items || {}, title = _a.title, describe = _a.describe, link = _a.link, _b = _a.extendProps, extendProps = _b === void 0 ? {} : _b;
                return (react_1.default.createElement("div", __assign({ className: "items", key: "".concat(index).concat(title) }, extendProps),
                    react_1.default.createElement("a", __assign({ href: link, className: "link" }, extendProps),
                        react_1.default.createElement("strong", null, title),
                        react_1.default.createElement("p", null, describe))));
            })));
        })),
        href && (react_1.default.createElement("a", __assign({ className: "all-link", href: href, target: "_blank", rel: "noreferrer" }, extendProps),
            txt,
            react_1.default.createElement(icon_1.Icon, { name: "arrow-enter", size: 28, color: '#006eff' })))));
};
ProductServiceMobile.displayName = 'ProductServiceMobile';
exports.default = react_1.default.memo(ProductServiceMobile);
//# sourceMappingURL=index.js.map